import React from "react";

/**
 * Jira-achtige status-lozenge: de kleur volgt de statuscategorie
 * (To do = grijs, Bezig = blauw, Klaar = groen), niet de statuskleur.
 * Voor de statuskleur zelf blijft BtwStatusPill bestaan.
 */
export const CATEGORY_STYLES = {
  todo: { lozenge: "bg-gray-100 text-gray-700 ring-gray-200", label: "To do" },
  in_progress: { lozenge: "bg-sky-50 text-sky-800 ring-sky-200", label: "Bezig" },
  done: { lozenge: "bg-emerald-50 text-emerald-800 ring-emerald-200", label: "Klaar" },
};

export const categoryOf = (status) => {
  if (!status) return "todo";
  if (status.category) return status.category;
  if (status.isTerminal) return "done";
  if (status.isDefault) return "todo";
  return "in_progress";
};

export const CATEGORY_OPTIONS = [
  { value: "todo", label: "To do" },
  { value: "in_progress", label: "Bezig" },
  { value: "done", label: "Klaar" },
];

const StatusLozenge = ({ status, text, category, size = "md", className = "" }) => {
  const cat = category ?? categoryOf(status);
  const s = CATEGORY_STYLES[cat] ?? CATEGORY_STYLES.todo;
  const sizes = size === "sm" ? "px-1.5 py-px text-[10px]" : "px-2 py-0.5 text-[11px]";
  const label = text ?? status?.name ?? "Geen status";
  return (
    <span
      className={`inline-flex max-w-full items-center truncate rounded font-semibold uppercase tracking-wide ring-1 ring-inset ${s.lozenge} ${sizes} ${className}`}
      title={label}
    >
      {label}
    </span>
  );
};

export default StatusLozenge;
